<span class="p-inputgroup inline">
    <span
        *ngIf="confirming && questionText"
        class="p-inputgroup-addon"
        data-purpose="question">
        {{ questionText }}
    </span>
    <button pButton
        *ngIf="confirming"
        [class]="cancelClass"
        [icon]="cancelIcon"
        [label]="iconsOnly ? null : cancelText"
        [title]="iconsOnly ? cancelText : null"
        (click)="DoCancel(); $event.preventDefault()"
        data-purpose="cancel"
        tabindex="-1"
        ></button>
    <button pButton
        [class]="confirming ? confirmClass : actionClass"
        [disabled]="isDisabled"
        [icon]="DisplayIcon()"
        [label]="iconsOnly ? null : (confirming ? confirmText : actionText)"
        [title]="iconsOnly ? (confirming ? confirmText : actionText) : null"
        (click)="DoAction(); $event.preventDefault()"
        data-purpose="action"
        [attr.role]="iconsOnly ? 'button' : ''"
        [attr.label]="iconsOnly ? (confirming ? confirmText : actionText) : ''"
        tabindex="-1"></button>
</span>
